import React from "react";

function Heart({ height = 14, width = 16 }) {
  return (
    <svg
      width={width}
      height={height}
      aria-hidden="true"
      focusable="false"
      viewBox="0 0 16 14"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M13.8933 2.0726C13.5528 1.73193 13.1485 1.46169 12.7036 1.27732C12.2586 1.09295 11.7817 0.998047 11.3 0.998047C10.8183 0.998047 10.3414 1.09295 9.89643 1.27732C9.45145 1.46169 9.04717 1.73193 8.70666 2.0726L8 2.77926L7.29333 2.0726C6.60554 1.3848 5.67269 0.998403 4.7 0.998403C3.72731 0.998403 2.79446 1.3848 2.10666 2.0726C1.41887 2.76039 1.03247 3.69324 1.03247 4.66593C1.03247 5.63862 1.41887 6.57147 2.10666 7.25926L2.81333 7.96593L8 13.1526L13.1867 7.96593L13.8933 7.25926C14.234 6.91876 14.5042 6.51447 14.6886 6.0695C14.873 5.62453 14.9679 5.14759 14.9679 4.66593C14.9679 4.18427 14.873 3.70733 14.6886 3.26236C14.5042 2.81739 14.234 2.4131 13.8933 2.0726V2.0726Z"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

export default Heart;
